import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store';
import { ENUM_BONUS_LABEL, ENUM_CUS_EVENT } from '../../../enums/enums';
import { API_USER } from '../../../api/user';
import useToast from '../../useToast';
import { dispatchCusEvent } from '../../../utils';
import { useDispatch } from 'react-redux';
import { setUpdateBonus } from '../../../store/apps/userSlice';

export default function useEditBonusStartBot(groupId) {
  const type = ENUM_BONUS_LABEL.startBot;
  const { successToast } = useToast();
  const dispatch = useDispatch();
  const bonusStartBot = useAppSelector((state) => state.user.bonus?.[groupId]?.[type]);

  const [updateSubgroups, setUpdateSubgroups] = useState(false);
  const [startBotStruct, setStartBotStruct] = useState(
    Array.isArray(bonusStartBot) ? {} : bonusStartBot || {}
  );

  const startBotEnable = startBotStruct?.enabled;
  const currencies = startBotStruct?.values;
  const curLangs = startBotStruct?.langs;
  const toDeposit = startBotStruct?.toDeposit;
  const lockSetting = startBotStruct?.updateLocked;
  const saveDisabled = !(currencies && Object.keys(currencies)?.length);

  const changeSubgroup = () => setUpdateSubgroups((prev) => !prev);
  const changeEnable = () => setStartBotStruct((prev) => ({ ...prev, enabled: !startBotEnable }));
  const changeDeposit = () => setStartBotStruct((prev) => ({ ...prev, toDeposit: !toDeposit }));
  const changeLockSetting = () => setStartBotStruct((p) => ({ ...p, updateLocked: !lockSetting }));

  const changeFieldValues = (name, value, currency) => {
    setStartBotStruct((prev) => {
      const newStartBot = JSON.parse(JSON.stringify(prev));
      if (!newStartBot.values) newStartBot.values = {};
      if (!newStartBot.values[currency]) newStartBot.values[currency] = {};
      newStartBot.values[currency][name] = value;

      return newStartBot;
    });
  };

  const changeBonusLangs = (name, value, lang) => {
    setStartBotStruct((prev) => {
      const newStartBot = JSON.parse(JSON.stringify(prev));
      if (!newStartBot.langs) newStartBot.langs = {};
      if (!newStartBot.langs[lang])
        newStartBot.langs[lang] = { botImage: '', botText: '', desktopImage: '', mobileImage: '' };
      newStartBot.langs[lang][name] = value;

      return newStartBot;
    });
  };

  const onSave = () => {
    const updateStore = () => {
      // если успех произошёл без ИД - то это создание
      if (!startBotStruct.id) {
        dispatchCusEvent(ENUM_CUS_EVENT.getBonusList, { groupId });
        setUpdateSubgroups(false);
        return;
      }
      const bonusData = { id: groupId, bonusName: type, data: startBotStruct };
      dispatch(setUpdateBonus(bonusData));
    };

    const updateData = {
      groupId: +groupId,
      bonusLabel: type,
      bonusData: startBotStruct,
      updateSubgroups
    };

    API_USER.group.bonus
      .update(updateData)
      .then((e) => {
        updateStore();
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (!bonusStartBot || Array.isArray(bonusStartBot)) return;
    setStartBotStruct(bonusStartBot);
  }, [bonusStartBot]);

  return {
    startBotEnable,
    currencies,
    curLangs,
    updateSubgroups,
    toDeposit,
    lockSetting,
    saveDisabled,
    changeLockSetting,
    changeEnable,
    changeSubgroup,
    changeDeposit,
    changeFieldValues,
    changeBonusLangs,
    onSave
  };
}
